const $body = $("body");
const start = true;
var isMobile = $(window).width() < 1024 ? true : false;

const sxImages = [
  "/assets/images/infradito/top-moros.png",
  "/assets/images/infradito/top-sketch.png",
  "/assets/images/infradito/top-write.png",
];

const dxImages = [
  "/assets/images/infradito/top-sun-dx.png",
  "/assets/images/infradito/top-moros-dx.png",
  "/assets/images/infradito/top-sun.png",
];

let mobileImages = [];

imgPreloading();

if (isMobile) {
  mobileImages = sxImages.concat(dxImages);
  // DISABLED: flashing of the images in homepage
  // imgFlasher(mobileImages, $(".infra-sx"));
} else {
  // DISABLED: flashing of the images in homepage
  // imgFlasher(sxImages, $(".infra-sx"));
  // imgFlasher(dxImages, $(".infra-dx"));
}

if (page == "privacy") {
  $(".menu").css("display", "none");
}

function imgPreloading() {
  let imagesArr = sxImages.concat(dxImages);
  let loadPercentUnit = 100 / imagesArr.length;
  let loadPercent = 0;
  imagesArr.forEach((url) => {
    $.get(url, () => {
      loadPercent += loadPercentUnit;
    });
  });
}

function goToAnchor(anchor, mobile) {
  if (page === "home") {
    var anchorOffset = $('[data-anchor="' + anchor + '"]').offset().top;
    $("body,html").animate(
      {
        scrollTop: anchorOffset + "px",
      },
      1500
    );
    if (mobile) {
      toggleMenu($(".nav-button"));
    }
  } else {
    window.location = "/#" + anchor;
  }
}

function toggleMenu(el) {
  if (!$(el).hasClass("clicked")) {
    $(el).addClass("clicked").addClass("clicked2");
    $(".mobile-menu").addClass("opened");
  } else {
    $(el).removeClass("clicked").removeClass("clicked2");
    $(".mobile-menu").removeClass("opened");
  }
}

function imgFlasher(imagesArr, img) {
  let imgFlasherTimeout = 0;
  imagesArr.forEach((imgUrl, index) => {
    setTimeout(function () {
      img.attr("src", imgUrl);
      setTimeout(function () {
        if (index == imagesArr.length - 1) {
          imgFlasher(imagesArr, img);
        }
      }, 800);
    }, imgFlasherTimeout);
    imgFlasherTimeout += 800;
  });
}

function sendMail() {
  var company = $("#company").val();
  var message = $("#message").val();
  var email = $("#email").val();
  var city = $("#city").val();
  var telephone = $("#telephone").val();
  var message = $("#message").val();

  $.ajax({
    type: "POST",
    url: "/mailer/post.php",
    data: {
      company: company,
      city: city,
      email: email,
      telephone: telephone,
      message: message,
    },
    success: function (text) {
      var data = $.parseJSON(text);
      if (data.success == true) {
        formSuccess();
      }
    },
  });
}

$("#mail-form").on("submit", function (e) {
  e.preventDefault();
  sendMail();
});

function formSuccess() {
  document.getElementById("mail-form").reset();
  $("#success-message").removeClass("d-none");
}

function goToLink(link) {
  window.location = link;
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const getMillisecondStamp = () => {
  var d = new Date();
  var t = d.getTime().toString();
  t = t.split("");
  t.forEach((letter, index) => {
    if (index > 9) {
      delete t[index];
    }
  });

  return t.join("");
};

const getDateFromTimestamp = (item) => {
  const date = new Date(item.timestamp * 1000);
  const dateObj = {
    hours: date.getHours(),
    minutes: date.getMinutes(),
    seconds: date.getSeconds(),
    day: date.getDate(),
    month: Number(date.getMonth()) + 1,
    year: date.getFullYear(),
  };
  return `${dateObj.day}/${dateObj.month}/${dateObj.year} ${dateObj.hours}:${dateObj.minutes}:${dateObj.seconds}`;
};

window.addEventListener("online", function () {
  console.log("online");
});

window.addEventListener("offline", function () {
  console.log("offline");
});
